// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1TU6R","alert":"SettungsInbox_alert__1a50s"};